import {
  DTODesignSystemVersionCreationResponse,
  DTODesignSystemVersionJobStatusResponse,
  DTODesignSystemVersionRoomResponse,
  DTODesignSystemVersionsListResponse,
} from "../../../dto";
import { DTOCreateVersionInput } from "../../../payloads";
import { RequestExecutor } from "../../../transport/request-executor";
import { BrandsEndpoint } from "./brands";
import { DocumentationEndpoint } from "./documentation";
import { DesignSystemComponentEndpoint } from "./ds-components";
import { ElementsEndpoint } from "./elements";
import { ElementsActionEndpoint } from "./elements-action";
import { FigmaComponentGroupsEndpoint } from "./figma-component-groups";
import { FigmaComponentsEndpoint } from "./figma-components";
import { FigmaFrameStructuresEndpoint } from "./figma-frame-structures";
import { ImportJobsEndpoint } from "./import-jobs";
import { ElementPropertyDefinitionsEndpoint } from "./property-definitions";
import { ElementPropertyValuesEndpoint } from "./property-values";
import { VersionStatsEndpoint } from "./stats";
import { ThemesEndpoint } from "./themes";
import { TokenCollectionsEndpoint } from "./token-collections";
import { TokenGroupsEndpoint } from "./token-groups";
import { TokensEndpoint } from "./tokens";
import { CodeComponentsEndpoint } from "./code-components";
import { FilesEndpoint } from "./files";

export class DesignSystemVersionsEndpoint {
  readonly themes: ThemesEndpoint;
  readonly brands: BrandsEndpoint;
  readonly tokenCollections: TokenCollectionsEndpoint;
  readonly importJobs: ImportJobsEndpoint;
  readonly tokens: TokensEndpoint;
  readonly tokenGroups: TokenGroupsEndpoint;
  readonly figmaComponents: FigmaComponentsEndpoint;
  readonly figmaComponentGroups: FigmaComponentGroupsEndpoint;
  readonly figmaFrameStructures: FigmaFrameStructuresEndpoint;
  readonly stats: VersionStatsEndpoint;
  readonly elementPropertyDefinitions: ElementPropertyDefinitionsEndpoint;
  readonly elementPropertyValues: ElementPropertyValuesEndpoint;
  readonly elementsAction: ElementsActionEndpoint;
  readonly elements: ElementsEndpoint;
  readonly designSystemComponents: DesignSystemComponentEndpoint;
  readonly documentation: DocumentationEndpoint;
  readonly codeComponents: CodeComponentsEndpoint;
  readonly files: FilesEndpoint;

  constructor(private readonly requestExecutor: RequestExecutor) {
    this.themes = new ThemesEndpoint(requestExecutor);
    this.brands = new BrandsEndpoint(requestExecutor);
    this.tokenCollections = new TokenCollectionsEndpoint(requestExecutor);
    this.importJobs = new ImportJobsEndpoint(requestExecutor);
    this.tokens = new TokensEndpoint(requestExecutor);
    this.tokenGroups = new TokenGroupsEndpoint(requestExecutor);
    this.figmaComponents = new FigmaComponentsEndpoint(requestExecutor);
    this.figmaComponentGroups = new FigmaComponentGroupsEndpoint(requestExecutor);
    this.figmaFrameStructures = new FigmaFrameStructuresEndpoint(requestExecutor);
    this.stats = new VersionStatsEndpoint(requestExecutor);
    this.elementPropertyDefinitions = new ElementPropertyDefinitionsEndpoint(requestExecutor);
    this.elementPropertyValues = new ElementPropertyValuesEndpoint(requestExecutor);
    this.elementsAction = new ElementsActionEndpoint(requestExecutor);
    this.elements = new ElementsEndpoint(requestExecutor);
    this.designSystemComponents = new DesignSystemComponentEndpoint(requestExecutor);
    this.documentation = new DocumentationEndpoint(requestExecutor);
    this.codeComponents = new CodeComponentsEndpoint(requestExecutor);
    this.files = new FilesEndpoint(requestExecutor);
  }

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions`, DTODesignSystemVersionsListResponse);
  }

  commit(dsId: string, body: DTOCreateVersionInput) {
    return this.requestExecutor.json(`/design-systems/${dsId}/head/commit`, DTODesignSystemVersionCreationResponse, {
      method: "POST",
      body,
    });
  }

  job(dsId: string, jobId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/jobs/${jobId}`,
      DTODesignSystemVersionJobStatusResponse
    );
  }

  room(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/room`,
      DTODesignSystemVersionRoomResponse
    );
  }
}
